import React, { useEffect, useState } from "react";
import { getTaxes, deleteTax } from "../../api/TaxService";
import { FaTrash } from "react-icons/fa";
export default function TaxList() {
  const [list, setList] = useState([]);
  // LOAD TAX LIST
  const loadData = async () => {
    try {
      const res = await getTaxes();
      setList(res?.data || res || []);
    } catch (error) {
    }
  };
  useEffect(() => {
    loadData();
  }, []);
  // DELETE TAX
  const handleDelete = async (id) => {
    try {
      const confirmDelete = window.confirm(
        "Are you sure you want to delete this tax?"
      );
      if (!confirmDelete) return;
      await deleteTax(id);
      alert("Tax deleted successfully");
      loadData(); 
    } catch (error) {
      alert("Failed to delete tax");
    }
  };
  return (
    <div className="container p-3">
      
      {list.length === 0 && <p>No tax found</p>}
      {list.map((tax) => (
        <div key={tax._id} className="card p-3 mb-2">
          <h5>{tax.taxName}</h5>
          <p>CGST: {tax.cgstPercentage}%</p>
          <p>SGST: {tax.sgstPercentage}%</p>
          <p>IGST: {tax.igstPercentage}%</p>
          <p>Total: {tax.totalTaxPercentage}%</p>
          <button
            className="btn btn-danger btn-sm"
            onClick={() => handleDelete(tax._id)}
          >
            <FaTrash /> Delete
          </button>
        </div>
      ))}
    </div>
  );
}